<template>
<div class="component">
    <div class="groupHeader columns is-mobile is-multiline">
        <div class="column is-8 is-offset-2">
            <h1 class="title">Gruppen des Quartiers</h1>
        </div>
        <div class="groupList">
            <div class="groupListItem" v-for="group in groups">

                <div class="box" @click="openGroup(group)">
                    <article class="media">

                        <div class="media-content">
                            <div class="content">
                                <p>
                                    <h1 class="groupTitle">{{group.title}}</h1>
                                    <br>
                                    <p class="groupDescription">
                                        {{group.description}}
                                    </p>
                                </p>
                            </div>

                        </div>
                    </article>
                </div>

            </div>
        </div>

    </div>

</div>
</template>

<script>
export default {
    name: 'GroupList',
    props: [],
    mounted: function () {
        this.getGroups();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            groups: [],
        }
    },
    methods: {
        getGroups() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.callApi("/group/all").then(function (response) {
                this.groups = response.data.groups;

            }.bind(this))

            
        },
        openGroup(group) {
            this.$emit("selectGroup", group);
        },

    },
    computed: {},
}
</script>

<style scoped>
.groupList {
    width: 100%;
}

.groupListItem {
    width: 90%;
    margin: 0.5% 5%;
    display: inline-block;
    cursor: pointer;
}

.groupTitle {
    text-align: center;
    width: 100%;
    display: inline-block;

}

.groupDescription {
    text-align: center;
}
</style>
